import type * as React from "react";

type CenteredLayoutProps = {
  children: React.ReactNode;
};

// react-doctor-disable-next-line react-doctor/only-export-components -- Pages Router layout module: the component is co-located with its required getLayout export.
function CenteredLayout({ children }: CenteredLayoutProps) {
  return (
    <div className="relative flex min-h-screen w-full flex-col justify-start">
      {children}
    </div>
  );
}

export const getLayout = (page: React.ReactElement) => (
  <CenteredLayout>{page}</CenteredLayout>
);
